import './ShipperShow.scss';

import { RefreshButton, Show, TextField } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCountryEnforcer } from '@/components/general/CountryEnforcer';
import PopupMenu from '@/components/general/PopupMenu';
import { ShowInfoGrid, ShowInfoItem } from '@/components/general/ShowInfo/ShowInfo';
import { ShowSubsection } from '@/components/general/ShowInfo/ShowSection';
import ProtectedDeleteButton from '@/components/protected/ProtectedDeleteButton';
import ProtectedEditButton from '@/components/protected/ProtectedEditButton';
import { useCountryContext } from '@/contexts/CountryContext';
import { usePermissionContext } from '@/contexts/PermissionContext';

const ShipperShow = () => {
  const { alert, blockEditForCountry } = useCountryEnforcer();
  const { t } = useTranslation();
  const { hasPermission } = usePermissionContext();
  const { isBrasilSelected } = useCountryContext();
  const hasMenuActions = useMemo(() => {
    return hasPermission('edit') || hasPermission('delete');
  }, [hasPermission]);
  const { query } = useShow();
  const { data, isLoading } = query;
  const record = data?.data;

  return (
    <Show
      isLoading={isLoading}
      headerButtons={({ refreshButtonProps, editButtonProps, deleteButtonProps }) => (
        <>
          <RefreshButton {...refreshButtonProps} hideText />
          {hasMenuActions && (
            <PopupMenu
              menuContent={
                <>
                  <ProtectedEditButton {...editButtonProps} type="text" />
                  <ProtectedDeleteButton {...deleteButtonProps} type="text" disabled={blockEditForCountry} />
                </>
              }
            />
          )}
        </>
      )}>
      {alert}
      {/* Datos del shipper: se muestran los campos de ubicación extraídos de la localidad anidada */}
      <div className="ShipperShow">
        <ShowSubsection title={t('Datos contacto')}>
          <ShowInfoGrid>
            <ShowInfoItem label={t('Id')}>
              <TextField value={record?.id} />
            </ShowInfoItem>
            <ShowInfoItem label={t('Nombre')}>
              <TextField value={record?.name} />
            </ShowInfoItem>
            <ShowInfoItem label={t('Teléfono')}>
              <TextField value={record?.phone ?? 'N/A'} />
            </ShowInfoItem>
            <ShowInfoItem label={t('Teléfono')}>
              <TextField value={record?.phone2 ?? 'N/A'} />
            </ShowInfoItem>
            <ShowInfoItem label={t('Email')}>
              <TextField value={record?.email ?? 'N/A'} />
            </ShowInfoItem>
            <ShowInfoItem label={t('Link de tracking')}>
              <TextField value={record?.tracking_link ?? 'N/A'} />
            </ShowInfoItem>
          </ShowInfoGrid>
        </ShowSubsection>
        <ShowSubsection title={t('Dirección')}>
          <ShowInfoGrid>
            <ShowInfoItem label={t('País')}>
              <TextField value={record?.localidad?.provincia?.pais?.nombre ?? '-'} />
            </ShowInfoItem>
            <ShowInfoItem label={isBrasilSelected ? 'UF' : t('Provincia')}>
              <TextField value={record?.localidad?.provincia?.nombre ?? '-'} />
            </ShowInfoItem>
            <ShowInfoItem label={isBrasilSelected ? t('Municipio') : t('Localidad')}>
              <TextField value={record?.localidad?.nombre ?? '-'} />
            </ShowInfoItem>
            <ShowInfoItem label={isBrasilSelected ? 'CEP' : t('Código postal')}>
              <TextField value={record?.postal_code ?? '-'} />
            </ShowInfoItem>
            <ShowInfoItem label={t('Dirección')}>
              <TextField value={record?.address ?? '-'} />
            </ShowInfoItem>

            {/* Número y complemento solo se muestran en el contexto de Brasil */}
            {isBrasilSelected && (
              <>
                <ShowInfoItem label={t('Número')}>
                  <TextField value={record?.address_number ?? '-'} />
                </ShowInfoItem>
                <ShowInfoItem label={t('Complemento')}>
                  <TextField value={record?.address_complement ?? '-'} />
                </ShowInfoItem>
              </>
            )}
          </ShowInfoGrid>
        </ShowSubsection>
      </div>

      {/* Campos de ubicación: se leen desde la estructura anidada localidad.provincia.pais */}
    </Show>
  );
};

export default ShipperShow;
